import { Box } from '@chakra-ui/react';
import React from 'react';

const ProjectCard = () => {
  return (
    <div>
      <Box my={2} border={'1px solid #EEEEEE'} borderRadius={5} p={2}>
        Project Card
      </Box>
    </div>
  );
};

export default ProjectCard;
